/**
 * extractOrgUnique — pure helper that pulls the org slug out of a URL path.
 *
 * The Calendar Month V2 page lives at `/org/{orgUnique}/calendar/month/...`.
 * The page derives the slug from the current location, then calls the
 * Symfony bootstrap APIs (`bootstrapSlice.fetchBootstrap`) with it.
 *
 * Returns `null` when the path does not contain an `/org/{slug}/` segment.
 * Numeric and dash-separated slugs are both accepted (the legacy slug
 * convention is `org-name-with-dashes-123`).
 *
 * @module extractOrgUnique
 */

const ORG_PATH_RE = /\/org\/([^/?#]+)/;

/**
 * @param {string} [pathname=window.location.pathname]
 * @returns {string|null}
 */
export function extractOrgUnique(pathname) {
	const source =
		typeof pathname === 'string'
			? pathname
			: typeof window !== 'undefined' && window.location
				? window.location.pathname
				: '';
	if (!source) return null;
	const match = source.match(ORG_PATH_RE);
	if (!match || !match[1]) return null;
	return match[1];
}
